import { apiClient } from '@/libs/axios';
import {
  toNotificationDeliveryDetailDTO,
  type NotificationDeliveryDetailDTO,
} from '../schemas/get-notification-delivery.schema';

/**
 * Delivery Retry. Sends synchronously and returns the updated detail; HTTP 200
 * only means the retry ran, so callers check `status` for the outcome.
 */
export const retryNotificationDelivery = async (
  id: string
): Promise<NotificationDeliveryDetailDTO> => {
  const response = await apiClient.post(`notification-delivery/${id}/retry`);

  return toNotificationDeliveryDetailDTO(response);
};
